import React from 'react';
const modules = [{
  title: 'Fondamenti della Danza™',
  description: 'Padroneggia biomeccanica del movimento, principi di insegnamento, ritmo, postura, recupero corporeo e prevenzione degli infortuni.'
}, {
  title: 'Libreria di Esercizi e Tecniche™',
  description: 'Un database completo di esercizi tecnici, sequenze di mobilità, movimenti di tonificazione e strumenti per lo sviluppo espressivo.'
}, {
  title: 'Sistema di Costruzione delle Sessioni™',
  description: 'Crea sessioni di danza professionali in pochi minuti con template collaudati, strutture di allenamento e framework di insegnamento.'
}, {
  title: "Routine Pronte all'Uso™",
  description: 'Oltre 50 routine già pronte per principianti, intermedie, danza espressiva, fitness dance, tonificazione e benessere corporeo.'
}, {
  title: 'Progettazione del Programma di Danza™',
  description: 'Costruisci programmi professionali di 4, 8 e 12 settimane con periodizzazione, progressione e framework di trasformazione corporea.'
}, {
  title: 'Strumenti di Coaching e Gestione delle Allieve™',
  description: 'Sistemi di valutazione, schede di monitoraggio, checklist di insegnamento e strumenti professionali per il coaching.'
}];
export function TomiSection() {
  return <section className="py-6 px-4 sm:px-6 bg-white border-y-4 border-brand-beige" data-id="element-164">
      <div className="text-center mb-4" data-id="element-165">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-166">
          LA SOLUZIONE CHE STAVI CERCANDO — UN SISTEMA COMPLETO 6 IN 1
        </h2>
        <p className="text-sm sm:text-base font-subheading font-bold text-brand-rose mb-2" data-id="element-167">
          6 Moduli Professionali In 1 Sistema Completo di Danza
        </p>
        <div className="inline-block bg-brand-rose text-white px-3 py-1 rounded mb-2 shadow-sm" data-id="element-168">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-169">
            🩰 DANZA READY™ — Box Set Completo 6 in 1
          </p>
        </div>
        <p className="text-sm text-brand-taupe font-medium leading-tight" data-id="element-170">
          DANZA READY™ è molto più di una raccolta di coreografie ed esercizi.
          È un sistema operativo completo per insegnanti e coach di danza,
          progettato per aiutarti a pianificare più velocemente, insegnare
          meglio e offrire programmi di danza professionali con piena sicurezza.
        </p>
      </div>

      <div className="flex flex-col gap-2" data-id="element-171">
        {modules.map((module, i) => <div key={i} className="bg-brand-cream border border-brand-beige p-2.5 rounded flex gap-2 items-center shadow-sm" data-id="element-172">
            <div className="text-brand-gold shrink-0" data-id="element-173">✅</div>
            <div data-id="element-174">
              <h3 className="text-sm font-bold text-brand-taupe leading-tight" data-id="element-175">
                {module.title}
              </h3>
              <p className="text-brand-taupe/80 text-xs font-medium leading-tight" data-id="element-176">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}